export default __webpack_public_path__ + "static/media/app.34c876e5.svg";